import { useState } from "react";

const faqs = [
  {
    q: "Üyelik başvurusu ücretli mi?",
    a: "Hayır, tamamen ücretsizdir. Platforma üye olmak, listelenmek ve ziyaretçilerden rezervasyon almak için herhangi bir ücret ödemezsiniz. Komisyon da alınmaz.",
  },
  {
    q: "Başvurum ne kadar sürede onaylanır?",
    a: "Editörlerimiz başvurunuzu genellikle 2-5 iş günü içinde inceler. Onay veya ret kararı, başvuruda belirttiğiniz e-posta adresine bildirilir.",
  },
  {
    q: "Hangi tür işletmeler başvurabilir?",
    a: "Otel, pansiyon, butik otel, apart daire, kamp & glamping alanları ve turizm firmaları başvurabilir. İşletmenizin Türkiye'de faaliyet gösteriyor olması yeterlidir.",
  },
  {
    q: "Başvurum reddedilirse ne olur?",
    a: "Ret gerekçesi e-posta ile bildirilir. Eksik veya hatalı bilgileri düzelterek yeniden başvurabilirsiniz. Çoğu ret, eksik bilgi veya fotoğraf nedeniyle gerçekleşir.",
  },
  {
    q: "Ziyaretçiler nasıl rezervasyon yapıyor?",
    a: "Ziyaretçiler işletme kartınızdaki telefon numaranızı görerek sizi doğrudan arayabilir ya da platform üzerindeki rezervasyon formu aracılığıyla mesaj gönderebilir. Tüm iletişim doğrudan sizinle kurulur.",
  },
  {
    q: "İşletme bilgilerimi sonradan güncelleyebilir miyim?",
    a: "Evet. Onaylanan işletmeler için bilgi güncelleme talebini e-posta yoluyla iletebilirsiniz. Fiyat, iletişim bilgisi, açıklama gibi tüm alanlar güncellenebilir.",
  },
  {
    q: "Harita üzerinde görünmek için ne gerekiyor?",
    a: "Başvurunuzda tam adresinizi doğru girmeniz yeterlidir. Onay sonrasında işletmeniz otomatik olarak interaktif haritada pin olarak gösterilir.",
  },
  {
    q: "\"Yeni Üye\" rozeti ne anlama geliyor?",
    a: "Platforma son 30 gün içinde katılan işletmeler, konaklama listesinde yeşil \"Yeni Üye\" rozetiyle öne çıkarılır. Bu rozet, ziyaretçilerin yeni işletmeleri keşfetmesini kolaylaştırır.",
  },
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div className="bg-stone-50 py-16 border-b border-stone-100">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <span className="inline-block bg-stone-200 text-stone-600 text-xs font-semibold px-4 py-1.5 rounded-full mb-3 uppercase tracking-widest">
            SSS
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
            Sık Sorulan Sorular
          </h2>
          <p className="text-stone-400 text-sm mt-3 max-w-lg mx-auto">
            Üyelik başvurusu hakkında merak ettiğiniz her şey burada. Cevabını bulamazsanız bize ulaşın.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`bg-white rounded-2xl border transition-all duration-200 overflow-hidden ${
                openIndex === i ? "border-amber-200" : "border-stone-100 hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer group"
              >
                <span className={`text-sm font-semibold leading-snug pr-4 transition-colors ${
                  openIndex === i ? "text-amber-700" : "text-stone-800 group-hover:text-stone-900"
                }`}>
                  {faq.q}
                </span>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-100 text-amber-600 rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-base"></i>
                </div>
              </button>

              {openIndex === i && (
                <div className="px-6 pb-5">
                  <div className="h-px bg-stone-100 mb-4"></div>
                  <p className="text-stone-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Still have questions */}
        <div className="mt-10 bg-amber-50 border border-amber-100 rounded-2xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-11 h-11 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-question-answer-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <p className="font-semibold text-stone-900 text-sm">Başka sorunuz mu var?</p>
              <p className="text-stone-400 text-xs mt-0.5">Cevabını bulamadığınız sorular için bize ulaşın.</p>
            </div>
          </div>
          <a
            href="mailto:info@turkiyeseyahatrehberi.com"
            className="flex items-center gap-2 px-5 py-2.5 bg-stone-900 text-white text-sm font-semibold rounded-xl hover:bg-stone-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line"></i>
            İletişime Geç
          </a>
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
